import { render } from "./4.LearnIhubTwo.vue?vue&type=template&id=ae4f8f9e&scoped=true"
import script from "./4.LearnIhubTwo.vue?vue&type=script&lang=js"
export * from "./4.LearnIhubTwo.vue?vue&type=script&lang=js"

import "./4.LearnIhubTwo.vue?vue&type=style&index=0&id=ae4f8f9e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae4f8f9e"]])

export default __exports__